import { useFormContext } from 'components/forms/form';
import React, { memo } from 'react';
import { Link } from 'react-router-dom';

interface IconButtonProps {
    icon?: React.ReactNode;
    to?: string;
    className?: string;
    onClick?: () => void;
    children?: React.ReactNode;
    colorScheme?: 'gray' | 'red' | 'blue' | 'green' | 'yellow';
    size?: 'small' | 'medium' | 'large';
    disabled?: boolean;
    state?: any; // For Link state
}

const IconButton: React.FC<IconButtonProps> = ({ icon, to, className = '', onClick, children, colorScheme = 'gray', size = 'medium', disabled = false, state }) => {

    const { disableInputs } = useFormContext()
    const isDisabled = disabled || disableInputs

    let colorClasses = {
        gray: `bg-gray-200 ${!isDisabled ? 'hover:bg-gray-300' : ''} [&>svg]:fill-black`,
        red: `bg-red-200 ${!isDisabled ? 'hover:bg-red-300' : ''} [&>svg]:fill-red-800`,
        blue: `bg-blue-200 ${!isDisabled ? 'hover:bg-blue-300' : ''} [&>svg]:fill-blue-800`,
        green: `bg-green-200 ${!isDisabled ? 'hover:bg-green-300' : ''} [&>svg]:fill-green-800`,
        yellow: `bg-yellow-200 ${!isDisabled ? 'hover:bg-yellow-300' : ''} [&>svg]:fill-yellow-800`,
    }[colorScheme];

    let sizeClasses = {
        small: 'h-8 w-8 [&>svg]:h-4 [&>svg]:w-4',
        medium: 'h-10 w-10 [&>svg]:h-6 [&>svg]:w-6',
        large: 'h-12 w-12 [&>svg]:h-8 [&>svg]:w-8',
    }[size];

    let classes = `${colorClasses} ${sizeClasses} ${isDisabled ? `opacity-30 cursor-not-allowed` : `cursor-pointer`} rounded-md ${className} flex items-center justify-center`;
    
    if (to && !isDisabled) {
        return (
            <Link
                to={to}
                className={classes}
                state={state}
            >
                {icon}{children}
            </Link>
        );
    } else {
        return (
            <div
                className={classes}
                onClick={!isDisabled ? onClick : undefined}
            >
                {icon}{children}
            </div>
        );
    }
}

export default memo(IconButton);

